import React from "react";
import { withRouter } from "react-router";
import AgregarUsuario from "./AgregarUsuario";
const EditarUsuario = props => {
    return <AgregarUsuario editar={true} />;
};

export default withRouter(EditarUsuario);
